import { render, staticRenderFns } from "./custom-image-input.component.vue?vue&type=template&id=b3fc0860&scoped=true&"
import script from "./custom-image-input.component.ts?vue&type=script&lang=ts&"
export * from "./custom-image-input.component.ts?vue&type=script&lang=ts&"
import style0 from "./custom-image-input.component.scss?vue&type=style&index=0&id=b3fc0860&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3fc0860",
  null
  
)

export default component.exports